export const pricingPermissions = {
    MANAGE_PPRICING: {
        key: 'Pricing.ManagePricing',
        name: 'Manage activities in the pricing database',
    }
}
